import api from "./api";

export async function fetchBlob(url, params) {
  const res = await api.get(url, { params, responseType: "blob" });
  const ct = String(res.headers?.["content-type"] || "");
  if (ct.includes("application/json")) {
    let msg = "Dosya oluşturulamadı";
    try { msg = JSON.parse(await res.data.text())?.detail || msg; } catch { /* yoksay */ }
    throw new Error(msg);
  }
  return res.data instanceof Blob ? res.data : new Blob([res.data]);
}

export async function downloadApi(url, filename, params) {
  const blob = await fetchBlob(url, params);
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 30000);
}

export async function printApiPdf(url, params) {
  const blob = await fetchBlob(url, params);
  const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
  const iframe = document.createElement("iframe");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  iframe.src = blobUrl;
  document.body.appendChild(iframe);
  await new Promise((resolve) => { iframe.onload = resolve; setTimeout(resolve, 4000); });
  try { iframe.contentWindow.focus(); iframe.contentWindow.print(); }
  catch { window.open(blobUrl, "_blank"); }
  setTimeout(() => { iframe.remove(); URL.revokeObjectURL(blobUrl); }, 120000);
}
